import {MtplTarifficationStep} from "./steps/MtplTarifficationStep";
import {MtplPersonalInfoStep} from "./steps/MtplPersonalInfoStep";
import {MtplVerificationStep} from "./steps/MtplVerificationStep";
import {MtplTarifficationStepSmartDrive} from "./steps/MtplTarifficationStepSmartDrive";
import {GreenTarifficationStep} from "./green_steps/GreenTarifficationStep";
import {GreenPersonalInfoStep} from "./green_steps/GreenPersonalInfoStep";
import {GreenVerificationStep} from "./green_steps/GreenVerificationStep";

export const steps: any = {
	"mtpl_online_00001": MtplTarifficationStep,
	"mtpl_online_00001_smart_drive": MtplTarifficationStepSmartDrive,
	"mtpl_online_00002": MtplPersonalInfoStep,
	"mtpl_online_00005": MtplPersonalInfoStep,
	"mtpl_online_00003": MtplVerificationStep,
	"greenCard_0001": GreenTarifficationStep,
	"greenCard_0002": GreenPersonalInfoStep,
	"greenCard_0003": GreenVerificationStep
};